export function slugifyTag(tag: string) {
  return tag
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function matchesTagSlug(tag: string, slug: string) {
  return slugifyTag(tag) === slug.trim().toLowerCase();
}
